import classNames from 'classnames';
import React from 'react';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { parseHint } from '../../utils/manager/hint-manager';

const pricePlaceHolder = 'price-select.placeholder';

function SelectPrice({ onChange, className, prices }) {
  // const { swalSelectClasses } = useSwal({ storage });
  const { t } = useTranslation();

  return (
    prices &&
    prices.length > 1 && (
      <Form.Control
        className={classNames(className)}
        onChange={(event) =>
          onChange(prices.find((price) => price.id === event.target.value))
        }
        // disabled={disabled}
        as="select"
        size="md"
      >
        <option value={null}>{t(pricePlaceHolder)}</option>

        {prices.map((price) => (
          <option key={price.id} value={price.id}>
            {parseHint(price.hint, false)}
          </option>
        ))}
      </Form.Control>
    )
  );
}

// SelectPrice.propTypes = {
//   storage: PropTypes.object.isRequired,
// };

// const SelectPriceRef = forwardRef(SelectPrice);

export { SelectPrice, pricePlaceHolder };
